export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7453.7cb4f2c2.jpg";